import React from 'react';

import NarrationBody from '~/components/ClaimPage/CliveApp/CliveNotifications/NarrationBody';
import type { StpNotification } from '~/components/ClaimPage/CliveApp/CliveNotifications/types';

import { LOG_MESSAGE_VISIBLE_LINES } from '../../constants';

interface LogEntryProps {
  notification: StpNotification;
}

/**
 * Narration: what the conductor did, in its own words. The default entry, and most of the log.
 *
 * A plain row rather than a card, and no connecting line down the feed. Both are deliberate —
 * there are eighty of these on a busy claim, nobody has to act on any of them, and giving
 * narration a frame is how a log stops being skimmable.
 */
const LogEntry: React.FC<LogEntryProps> = ({ notification }) => (
  <div className="flex gap-12">
    <div className="flex w-20 shrink-0 justify-center pt-[5px]">
      <div className="h-[8px] w-[8px] rounded-full border-2 border-solid border-grey-300 bg-white" aria-hidden />
    </div>
    <div className="min-w-0 flex-1">
      <NarrationBody notification={notification} visibleLines={LOG_MESSAGE_VISIBLE_LINES} />
    </div>
  </div>
);

export default LogEntry;
